import {
    setPage,
    setPageSize,
} from '../reducers';

import {
    selectVisibility,
    visibilityStateSelector,
} from '../selectors';
import {
    useAppDispatch,
    useAppSelector
} from '../../../../hooks/useTypedReactRedux';

import {useApplicationsQuery} from './useApplicationsQuery';

// FNP-947: paging counts must come from the records React Query fetched.
// Reading them from the (now absent) Redux records slice would report 0 pages
// while the table renders rows - the FNP-950 defect.
export const useApplicationsPaging = () => {

    const dispatch = useAppDispatch();

    const visibility = useAppSelector((state) => visibilityStateSelector(state));
    const {data} = useApplicationsQuery();

    const {
        limit,
        page,
        totalPages,
        visibleCount,
    } = selectVisibility(visibility, data ?? []);

    const handleItemsPerPageChange = (pageSize: string | null) => {
        dispatch(setPageSize(pageSize));
    };

    const handlePageChange = (page: number) => {
        dispatch(setPage(page));
    };

    return {
        limit,
        page,
        totalPages,
        // The old selector exposed this as `totalCount`; selectVisibility calls
        // it visibleCount. Kept under the original name for callers.
        totalCount: visibleCount,
        handleItemsPerPageChange,
        handlePageChange,
    };
};
